import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');

const tree = (
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
);

// scripts/prerender.js snapshots the fully-rendered DOM of every URL in
// sitemap.xml, stamps it with <meta name="x-prerendered">, and writes it over
// that route's index.html. On those pages #root already holds React's own
// output, so we attach to it with hydrateRoot instead of discarding it and
// rendering from scratch — that is what removes the flash of blank content
// between the HTML arriving and React booting.
//
// It has to be the meta tag that decides, NOT `container.hasChildNodes()`.
// public/index.html deliberately ships a hand-written lookalike of the homepage
// hero inside #root for crawlers and slow connections, so #root is never empty
// and hasChildNodes() is always true. Hydrating against that hand-written markup
// would hand React a tree it never produced — a guaranteed mismatch on every
// route that has no snapshot.
//
// Absent the marker this is exactly the previous createRoot behaviour, so the
// file is safe to ship with or without the prerenderer.
if (document.querySelector('meta[name="x-prerendered"]')) {
    hydrateRoot(container, tree);
} else {
    createRoot(container).render(tree);
}
